var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-container',{staticClass:"grid-list-md"},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"fixed":false,"app":""}},[_c('span',[_vm._v("© Risiko Management Service")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }